import { parse, type DocumentNode } from 'graphql';

// Codegen emits operation types from the matching .graphql files. These runtime
// documents must stay AST-identical to those sources.
export const VOTER_LIST_DOCUMENT: DocumentNode = parse(/* GraphQL */ `
  query VoterList($search: String, $state: String, $first: Int, $offset: Int) {
    voterList(search: $search, state: $state, first: $first, offset: $offset) {
      total
      items {
        id
        voterId
        state
        firstName
        lastName
        household {
          id
          address1
          address2
          city
          state
          zip
        }
      }
    }
  }
`);

export const VOTER_REGISTRATION_STATES_DOCUMENT: DocumentNode = parse(/* GraphQL */ `
  query VoterRegistrationStates {
    voterRegistrationStates
  }
`);

export const VOTER_DETAIL_DOCUMENT: DocumentNode = parse(/* GraphQL */ `
  query VoterDetail($id: ID!) {
    voterDetail(id: $id) {
      id
      voterId
      state
      firstName
      lastName
      household {
        id
        address1
        address2
        city
        state
        zip
        lat
        lng
      }
    }
  }
`);

export const VOTER_DOOR_VISITS_DOCUMENT: DocumentNode = parse(/* GraphQL */ `
  query VoterDoorVisits($id: ID!, $first: Int, $offset: Int) {
    voterDoorVisits(id: $id, first: $first, offset: $offset) {
      total
      items {
        association
        visit {
          doorVisitId
          dwellStartedAt
          canvasserId
          visitStatus
        }
      }
    }
  }
`);
